<template>
    <div>
        <q-expansion-item
            icon="search"
            :label="$t('actions.search')"
            defaultOpened
            class="ContextDrawerExpansion q-mb-sm"
            header-class="ContextDrawerExpansionHeader"
        >
            <div class="ContextDrawerExpansionContent">
                <QInput
                    v-model="searchProxy"
                    dense
                    outlined
                    type="search"
                    :label="$t('actions.search')"
                    class="q-mb-md"
                    @keyup.enter="$emit('apply-search')"
                >
                    <template #append>
                        <q-icon
                            v-if="searchProxy"
                            name="close"
                            size="20px"
                            clickable
                            style="margin-right: 0.5rem;cursor: pointer;"
                            @click="handleClearSearch"
                        />
                        <q-icon
                            name="search"
                            size="20px"
                            clickable
                            style="cursor: pointer;"
                            @click="$emit('apply-search')"
                        />
                    </template>
                </QInput>
            </div>
        </q-expansion-item>

        <q-expansion-item
            icon="tune"
            :label="$t('general.filters')"
            defaultOpened
            class="ContextDrawerExpansion ContextDrawerExpansion--last"
            header-class="ContextDrawerExpansionHeader"
        >
            <div class="ContextDrawerExpansionContent">
                <div class="flex row-left-center q-mb-md">
                    <QToggle
                        name="alreadySeen"
                        color="primary"
                        :modelValue="alreadySeen"
                        @update:model-value="$emit('visibility-change', $event)"
                    />
                    <div class="text-caption q-ml-sm">
                        {{ $t('notifications.showActives') }}
                    </div>
                </div>

                <QInput
                    :modelValue="startDate"
                    dense
                    outlined
                    type="date"
                    :label="$t('general.startAt')"
                    stackLabel
                    class="q-mb-md"
                    @update:modelValue="$emit('start-date-change', $event)"
                />
                <QInput
                    :modelValue="endDate"
                    dense
                    outlined
                    type="date"
                    :label="$t('general.endAt')"
                    stackLabel
                    @update:modelValue="$emit('end-date-change', $event)"
                />
            </div>
        </q-expansion-item>
    </div>
</template>

<script>
export default {
    name: 'OrganizationNotificationsDrawerPanel',
    props: {
        search: {
            type: String,
            default: '',
        },
        alreadySeen: {
            type: Boolean,
            required: true,
        },
        startDate: {
            type: String,
            required: true,
        },
        endDate: {
            type: String,
            required: true,
        },
    },
    emits: [
        'apply-search',
        'visibility-change',
        'start-date-change',
        'end-date-change',
        'update:search',
    ],
    computed: {
        searchProxy: {
            get() {
                return this.search
            },
            set(value) {
                this.$emit('update:search', value)
            },
        },
    },
    methods: {
        handleClearSearch() {
            this.$emit('update:search', '')
            this.$emit('apply-search')
        },
    },
}
</script>

<style scoped lang="scss">
:deep(.ContextDrawerExpansion) {
    border-top: 1px solid $gray-04;
}

:deep(.ContextDrawerExpansion.ContextDrawerExpansion--last) {
    border-bottom: 1px solid $gray-04;
}

:deep(.ContextDrawerExpansionHeader .q-item__label) {
    font-weight: 700;
}

:deep(.ContextDrawerExpansionHeader .q-item__section--avatar .q-icon) {
    color: $primary;
}

.ContextDrawerExpansionContent {
    padding: 8px 16px 16px;
}
</style>
